export enum OfferType {
  OFFER = 'offer',
  COUNTER_OFFER = 'counter_offer',
}

export enum OfferState {
  SENT = 'sent',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  CANCELED = 'canceled',
}

type BaseOfferPayload = {
  pool_id: number;
  type: OfferType;
};

export type SendOfferPayload = BaseOfferPayload & {
  type: OfferType.OFFER;
};

export type OfferCounterInfo = {
  required_documents: string[];
  amount: string | null;
  roi_rate: string | null;
  term_months: number;
  note: string;
};

export type MakeCounterOfferPayload = BaseOfferPayload & {
  type: OfferType.COUNTER_OFFER;
  counter_offer_info_schema: OfferCounterInfo;
};

export type OfferPayload = SendOfferPayload | MakeCounterOfferPayload;

export type RespondToOfferPayload = {
  pool_id: number;
  offer_id: number;
  type: OfferType;
  state: OfferState;
  counter_offer_info: OfferCounterInfo | null;
};

export type DeleteOfferPayload = {
  pool_id: number;
  offer_id: number;
};
